<template>
    <f7-page id="reset-password-verify-email" name="reset-password-verify-email" @page:afterin="afterin">
        <div class="block">
            <div class="b fs-24 mb-md text-align-center">{{$t('account-reset-password-check-email')}}</div>
            <div class="fs-14 fw-medium mb-xxl text-color-gray text-align-center">
                {{$t('account-reset-password-check-email-text')}}
            </div>

            <div class="text-align-center pt-xxl">
                <div><img :src="require('@/assets/img/icon/icon-email.svg')" style="" /></div>
            </div>
            <f7-button @click="goToNextPage" large fill :disabled="!isNextButtonValid" class="view-desktop mt-6">{{$t('account-reset-password-back-login')}}</f7-button>
        </div>

        <f7-toolbar position="bottom" no-hairline class="toolbar-with-button view-mobile">
            <f7-button large fill @click="goToNextPage" :disabled="!isNextButtonValid">
                {{$t('account-reset-password-back-login')}}
            </f7-button>
        </f7-toolbar>
    </f7-page>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        mounted (){

        },
        data() {
            return {
                isNextButtonValid : true
            }
        },
        methods: {
            ...mapActions('customer', []),
            
            afterin(){
                window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
            },
            goToNextPage(){
                this.$f7router.navigate("/login");
            },

            backButton() {
                this.$f7router.back({ transition: 'f7-push' });
            }
        },
        computed: {
            ...mapGetters('customer', [

            ])
        }
    }
</script>